import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { BarChart3, BookOpen, ReceiptText } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import './SalesTeamHub.css';

const ORDER = ['Ginny', 'Zac', 'JQ', 'Zen'];

const personLinks = person => {
  const name = person.name.toLowerCase();
  const links = [{ label: 'Performance', to: `/salesperson/${person.id}?tab=analytics`, icon: BarChart3 }];
  if (['jq', 'zen'].includes(name)) links.push({ label: 'Bookings', to: `/${name}-bookings`, icon: BookOpen });
  links.push({
    label: 'Commission',
    to: name === 'jq' ? '/jq-commission' : `/salesperson/${person.id}?tab=commission`,
    icon: ReceiptText,
  });
  return links;
};

export default function SalesTeamHub({ month }) {
  const { token } = useAuth();
  const [people, setPeople] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let disposed = false;
    setLoading(true);
    setError('');
    axios.get(`/api/dashboard/overview?month=${month}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(response => {
        if (disposed) return;
        const team = (response.data.salespeople || [])
          .filter(person => ORDER.includes(person.name))
          .sort((a, b) => ORDER.indexOf(a.name) - ORDER.indexOf(b.name));
        setPeople(team);
      })
      .catch(() => { if (!disposed) setError('The sales team could not be loaded.'); })
      .finally(() => { if (!disposed) setLoading(false); });
    return () => { disposed = true; };
  }, [month, token]);

  return <div className="sales-team-hub">
    <p className="sales-team-intro">Choose a person, then open the page you need.</p>

    {loading && <div className="sales-team-state" role="status">Loading sales team…</div>}
    {error && <div className="sales-team-state error" role="alert">{error}</div>}
    {!loading && !error && <div className="sales-team-grid" aria-label="Sales team directory">
      {people.map(person => <section className="sales-team-card" key={person.id}>
        <div className="sales-team-person">
          <div className={`sales-team-avatar person-${person.name.toLowerCase()}`}>{person.name.slice(0, 2)}</div>
          <div><h2>{person.name}</h2><p>{person.role || 'Salesperson'}</p></div>
        </div>
        <nav aria-label={`${person.name} pages`} className="sales-team-actions">
          {personLinks(person).map(({ label, to, icon: Icon }) => <Link key={label} to={to}>
            <Icon size={17} aria-hidden="true" /><span>{label}</span>
          </Link>)}
        </nav>
      </section>)}
    </div>}
  </div>;
}
